import { useSlideContext, Video } from '@cian/slider';
import * as React from 'react';
import ReactPlayer from 'react-player/lazy';

import * as styles from './VideoPlayable.css';

interface IVideoPlayableProps extends React.ComponentProps<typeof Video> {
  playable?: boolean;
}

export const VideoPlayable: React.FC<IVideoPlayableProps> = ({ src, playable, ...sharedProps }) => {
  const { isActive } = useSlideContext();
  const [isPlaying, setIsPlaying] = React.useState(playable && isActive);
  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (!playable) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      setIsPlaying(true);
    },
    [playable],
  );

  React.useEffect(() => {
    if (!isActive) {
      setIsPlaying(false);
    }
  }, [isActive]);

  if (isPlaying) {
    return <ReactPlayer data-testid="GalleryReactPlayer" url={src} width="100%" height="100%" controls playing />;
  }

  return (
    <div data-testid="GalleryVideoPreview" className={styles['container']} onClick={handleClick}>
      <Video src={src} {...sharedProps} />
    </div>
  );
};
